import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { SupportServiceCategory } from '@src/api/types/supportServiceCategory';

type CompanySupportServiceCategoryIndexResponse = SupportServiceCategory[];

export const companySupportServiceCategoryApiClient = {
  index: async (): Promise<ApiResult<CompanySupportServiceCategoryIndexResponse>> => {
    return await axiosClient.get('/company/support-service-categories');
  },
};
